import React, { useCallback } from 'react';
import { ToggleButton } from '@mui/material';
import YouTubeIcon from '@mui/icons-material/YouTube';
import PropTypes from 'prop-types';
import { useTranslate } from 'ra-core';

// Update YoutubeButton component to use props directly
export const YoutubeButton = ({ editor, ...props }) => {
    const translate = useTranslate();

    const label = translate('ra.tiptap.youtube', { _: 'YouTube' });

    const addYoutubeVideo = useCallback(() => {
        const url = window.prompt(
            translate('ra.tiptap.youtube_dialog', { _: 'YouTube URL' })
        );

        if (url) {
            editor.chain().focus().setYoutubeVideo({
                src: url,
                width: 640,
                height: 480,
            }).run();
        }
    }, [editor, translate]);

    return (
        <ToggleButton
            aria-label={label}
            title={label}
            {...props}
            disabled={!editor || !editor.isEditable}
            value="youtube"
            onClick={addYoutubeVideo}
        >
            <YouTubeIcon fontSize="inherit" />
        </ToggleButton>
    );
};

// Define prop types
YoutubeButton.propTypes = {
    editor: PropTypes.object.isRequired,
};
